/* React Imports */
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

/* Styling Imports */
import './scss/auth.scss';
import { Row, Col, Form, Input, Image, Button, message } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Folio3AIIcon } from 'assets/icons';
import AuthImg from '../../assets/img/main-banner.png';

/* API Services */
import axios from 'axios';
import AuthService from 'api-services/auth-service';
//import ReCAPTCHA from 'react-google-recaptcha';

/* Hooks */
import useLoading from 'hooks/use-loading';

const Login = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  //const recaptchaRef = useRef();

  /* Custom Hooks */
  const { setLoading } = useLoading();

  /* Component States */
  const [, forceUpdate] = useState({});

  /* Hardcoded Errors */
  const emailError = 'Please enter your email address!';
  const passwordError = 'Please enter your password!';

  /* Login form validation schema */
  const schema = Yup.object().shape({
    email: Yup.string().email(emailError).required(emailError),

    password: Yup.string().required(passwordError),
  });

  /* Ant form integration with Yup */
  const yupSync = {
    async validator({ field }, value) {
      await schema.validateSyncAt(field, { [field]: value });
    },
  };

  /* Logging In */
  const validateBackend = async (values) => {
    const obj = {
      //object holds validity status and errors if any
      isValid: true,
      errors: [],
    };

    let token;
    /*
    try{
      setLoading(true);
      token = await recaptchaRef.current.executeAsync();
    } catch (err){
      message.error('Something went wrong, please try again!');
      obj.isValid=false;
      return obj;
    } finally{
      setLoading(false);
    }
    */

    try {
      setLoading(true);
      const response = await axios.post(process.env.REACT_APP_BASE_URL + 'auth/email/login', values, {
        headers:{
          'Captcha-token': token,
        },
      }); //log in with backend
      await AuthService.login(response.data); //storing token
    } catch (err) {
      obj.isValid = false;

      if (err.response && err.response.data && err.response.data.errors) {
        //checking for any errors
        if (err.response.data.errors.email === 'emailNotExists') {
          //email errors
          obj.errors.push({
            name: 'email',
            value: values.email,
            errors: ['Invalid Email'],
          });
        } else if (err.response.data.errors.password === 'incorrectPassword') {
          //password errors
          obj.errors.push({
            name: 'password',
            value: values.password,
            errors: ['Invalid Password'],
          });
        } else if (err.response.data.status === 403) {
          message.error(err.response.data.errors.message);
        }
      } else {
        message.error('Something went wrong, please try again!');
      }
    } finally {
      setLoading(false);
    }

    return obj;
  };

  /* Login form submission */
  const onFinish = async (values) => {
    const validationResult = await validateBackend(values); //validating with backend
    if (validationResult.isValid) {
      //navigating to dashboard if successfull
      navigate('/chatbots');
    } else {
      form.setFields(validationResult.errors); //passing errors to UI
    }
  };

  /* Use Effects */
  useEffect(() => {
    message.destroy();
    forceUpdate({});
    if (AuthService.isAuthenticated()) navigate('/');
  }, []);

  /* UI */
  return (
    <Row className='auth-container'>
      <Col span={10} className='auth-form-container'>
        <div>
          <a href='/' target='_blank' title='Chat Buddy Pro'>
            <Folio3AIIcon />
          </a>
          <h2>Login to your account</h2>
          <Form id='login' form={form} size='large' name='horizontal_login' layout='vertical' onFinish={onFinish}>
            <Form.Item label='Email Address' name='email' rules={[yupSync]}>
              <Input prefix={<UserOutlined className='site-form-item-icon' />} placeholder='Enter Email Address' />
            </Form.Item>
            <Form.Item label='Password' name='password' rules={[yupSync]}>
              <Input prefix={<LockOutlined className='site-form-item-icon' />} type='password' placeholder='Password' />
            </Form.Item>
            <div className='fp-block'>
              <Link to={'/register'}>Sign up?</Link> or
              <Link to={'/forgot-password'}> Forgot Password?</Link>
            </div>
            {/*<ReCAPTCHA
              ref={recaptchaRef}
              size="invisible"
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            />*/}
            <Form.Item shouldUpdate className='action-btn'>
              {() => (
                <Button
                  type='primary'
                  htmlType='submit'
                  disabled={!!form.getFieldsError().filter(({ errors }) => errors.length).length}>
                  Sign In
                </Button>
              )}
            </Form.Item>
          </Form>
        </div>
      </Col>
      <Col span={14} className='auth-cover'>
        <div>
          <Image preview={false} src={AuthImg} />
        </div>
      </Col>
    </Row>
  );
};

export default Login;
